import { render, staticRenderFns } from "./LinkedPracticesSummary.vue?vue&type=template&id=48c69e73&"
import script from "./LinkedPracticesSummary.vue?vue&type=script&lang=js&"
export * from "./LinkedPracticesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports